import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'

import VueCordova from 'vue-cordova';
Vue.use(VueCordova);

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import Table from 'buefy'
import Loading from 'buefy'
import { ToastProgrammatic as Toast } from 'buefy'
Vue.use(Table, Toast, Loading);

import vuexI18n from 'vuex-i18n'
Vue.use(vuexI18n.plugin, store);

import translationsPt from './translations/pt-PT/pt-PT'
import translationsEn from './translations/en-GB/en-GB'
Vue.i18n.add('pt', translationsPt);
Vue.i18n.add('en', translationsEn);
let browserLanguage = null;
if(localStorage.getItem('language')) browserLanguage = localStorage.getItem('language');
else browserLanguage = 'pt';
Vue.i18n.set(browserLanguage);


import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);


import VueApexCharts from "vue-apexcharts";
Vue.component("apexchart", VueApexCharts);


import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);


import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load:{ key: 'AIzaSyChLNxP-u1EKhfPnoSkZSuOp0OX476AbQI', libraries: 'places'}
});


import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);


//LOAD MEMBERS 
import {getAll} from "./api/Member/apiMember.js";
export function getMembers() {
  getAll()
    .then(response => {
        for (var i = 0; i < response.data.body.length; i++) {
            response.data.body[i].number = response.data.body[i].number.toString();
            if(response.data.body[i].email=='undefined' || response.data.body[i].email=='null') response.data.body[i].email='';
            if(response.data.body[i].phone_number=='undefined' || response.data.body[i].phone_number=='null') response.data.body[i].phone_number='';
            if(response.data.body[i].notes=='undefined' || response.data.body[i].notes=='null') response.data.body[i].notes='';
            if(response.data.body[i].address=='undefined' || response.data.body[i].address=='null') response.data.body[i].address='';
        }
        let data = response.data.body;
        localStorage.setItem('members', JSON.stringify(data));
    })
}
window.setInterval(() => {
  getMembers();
}, 60000)


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
